import { useIndicatorStore } from '@/stores/indicatorStore';

export const useIndicator = () => {
  const { showIndicator, hideIndicator } = useIndicatorStore();

  const showLoading = (
    message?: string,
    subMessage?: string,
    waitForAnimationCycle?: boolean,
  ) => {
    showIndicator({
      message,
      subMessage,
      waitForAnimationCycle,
    });
  };

  const hideLoading = () => {
    hideIndicator();
  };

  /**
   * Promise를 실행하는 동안 로딩 인디케이터를 표시
   * Promise가 완료되면 인디케이터를 자동으로 숨김
   */
  const withLoading = async <T>(
    promise: Promise<T>,
    message?: string,
    subMessage?: string,
    waitForAnimationCycle?: boolean,
  ): Promise<T> => {
    try {
      showLoading(message, subMessage, waitForAnimationCycle);
      return await promise;
    } finally {
      hideLoading();
    }
  };

  return { showLoading, hideLoading, withLoading };
};
